import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class UtilityService {
    // list of regExp pattarn. Please maintain the ASCENDING ORDER
    regExp = {
        alphaNum: '^[a-zA-Z0-9]*$',
        userName: '^[aA-zZ]\\w*$',
        lastName: '^[aA-zZ]?$',
        gstn: '^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[a-zA-Z0-9]{3}$',
        password: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/,
        phoneWithCode: '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$',
        phoneCode: /^[+][0-9]{1,4}$/,
        phoneNo: /^(\d[.\-\s]?){7,11}\d$/,
        mobileNo: '/^[6-9]\d{9}$/',
        email: '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}',
        zipCode: '[0-9]{5,6}$',
        fullName: /^[a-zA-Z]+(\s{1}[a-zA-Z]+)?$/
    };

    constants = {
        wkDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }

    constructor(private router: Router) { }

    /**
     * this function is to check empty object
     * if empty return true else false
     * @param obj object to be passed
     * @returns boolean true | false
     */
    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    /**
 * this function is to write either in local storage or session storage
 * @key name of the key
 * @value value to be set in localstorage or sessionStorage
 * @store type of storage either localStorage or sessionStorage
 * @remember is optional boolean if true set as localStorage else sessionStorage
 */
    writeStorage(key: string, value: any, store?, remember?: boolean): void {
        store = remember ? localStorage : (store || sessionStorage);
        value = (typeof value === 'object') ? JSON.stringify(value) : String(value);
        store.setItem(key, value);
    }

    /**
     * this function is to read and return the storage value
     * @param name of the key
     * @param store type of storage either localStorage or sessionStorage
     * @returns store data | false
     */
    readStorage(key, store): any | boolean {
        store = store || localStorage;
        const storeData = JSON.parse(store.getItem(key));
        return storeData ? storeData : false;
    }
    getStorage(key) {
        return JSON.parse(sessionStorage.getItem(key)) || [];
    }
    //to log out chakri changes start
    logout() {
        // remove user from local storage to log user out
        sessionStorage.clear();
        localStorage.removeItem('b2cUser');
        this.router.navigateByUrl('/');
        window.location.reload();
    }
    reloadCurrentRoute() {
        let currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
        });
    }
    //to log out chakri changes end
    compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    /**
     * This will give random number between the any range with (min and max) value
     * @param min minimum value to be passed(lower bound)
     * @param max maximum value to be passed(upper bound)
     */
    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    /**
     * This function return the age a person pon provided DOB date inastance
     * @param birthday is the instance of a Date
     */

    calculateAge(birthday) { // birthday is a date instance
        let tempDate = (birthday instanceof Date) ? birthday.getTime() : new Date(birthday).getTime();
        let ageDifMs = Date.now() - tempDate;
        let ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    calculateDateOfBirthFromAge(age: number): string {
        let birthYear = new Date().getFullYear() - age;
        let birthDate = new Date(birthYear, 0, 1); // Assuming Jan 1st as birth date
        return birthDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    }    

    /**
     * This function is to convert the number into string or vice versa
     * @param val is either a string or number 
     * @param toType is to convert into either number or string
     */

    getParsed(val: any, toType?) {
        toType = typeof toType == 'undefined' ? '' : toType;
        let castedVal: any;
        switch (toType) {
            case 'number': castedVal = Number(val);
                break;
            case 'string': castedVal = String(val);
                break;
            default: castedVal = Number(val);
                break;
        }
        return castedVal;
    }

    /**
     * this function is to find numbers of days/nights
     * @param i in time 
     * @param o out time
     */

    noOfNights(i, o) {
        return Number((new Date(o).getTime() - new Date(i).getTime()) / (1000 * 60 * 60 * 24));
    }

    /**
     * This function is to test two object are same or not.
     * @param a obeject one
     * @param b object two
     */

    isEquivalentObject(a, b) {
        // Create arrays of property names
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);

        // If number of properties is different,
        // objects are not equivalent
        if (aProps.length != bProps.length) {
            return false;
        }

        for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];

            // If values of same property are not equal,
            // objects are not equivalent
            if (a[propName] !== b[propName]) {
                return false;
            }
        }

        // If we made it this far, objects
        // are considered equivalent
        return true;
    }

    /**
     * This function is to get the name of the weekdays 
     * @param d if short form of days like Sun
     * @returns Fullday like Sunday
     */
    getWeekDay(d: string) {
        let tempDay: string = ''
        this.constants.wkDays.forEach(day => {
            let regex = new RegExp(d, 'gi');
            if (day.match(regex)) {
                tempDay = day;
            }
        });
        return tempDay;
    }

    /**
 * This function is to get the name of the months 
 * @param d if short form of months like Jan
 * @returns Fullday like January
 */
    getFullMonth(d: string) {
        let tempMonth: string = ''
        this.constants.months.forEach(month => {
            let regex = new RegExp(d, 'gi');
            if (month.match(regex)) {
                tempMonth = month;
            }
        });
        return tempMonth;
    }

    /**
     * this function is to formate date from yyyy-mm-dd to dd-mm-yyyy and vice versa
     * @param date date in this given format either yyyy-mm-dd or dd-mm-yyyy
     */

    formateDate(date: string): string {
        let formatedDate = '', temp = date.split('-');
        formatedDate = `${temp[2] + '-' + temp[1] + '-' + temp[0]}`;
        return formatedDate;
    }

    getDay(date) {
        let d = new Date(date);
        let weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        return weekday[d.getDay()];
    }
    /*To accept only numbers*/
    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }

    calculateDiff(fromDate, toDate) {
        fromDate = new Date(fromDate);
        toDate = new Date(toDate);
        return Math.floor((Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate()) - Date.UTC(toDate.getFullYear(), fromDate.getMonth(), fromDate.getDate())) / (1000 * 60 * 60 * 24));
    }

    calculateDiffTime(fromDate, toDate) {
        fromDate = new Date(fromDate);
        toDate = new Date(toDate);
        const diffInMs = Date.parse(toDate) - Date.parse(fromDate);
        const diffInHours = diffInMs / 1000 / 60;
        return diffInHours;
    }

    calculateDuration(fromDate, toDate) {
        fromDate = new Date(fromDate);
        toDate = new Date(toDate);
        const diffInMs = Date.parse(toDate) - Date.parse(fromDate);
        const diffInHours = diffInMs / 1000 / 60;
        return this.timeConvert(diffInHours);
    }

    timeConvert(n) {
        var num = n;
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        return (rhours > 0 ? (rhours + " hr ") : '') + rminutes + " min";
    }

    checkSeatSelection(passengers) {
        let hasValue = false;
        for (const passenger of passengers) {
            if (passenger.SeatInfo.length > 0) {
                hasValue = true;
                break;
            }
        }
        return hasValue;
    }

}